<template>
  <div class="invoice">
    <MerchantLogo
      :merchant-logo-url="company.company_logo_url"
      :document-title="invoice.document_title" />
    <MerchantInvoiceDetails
      :merchant="company"
      :invoice="invoice"
      :pill-color-class="pillColorClass" />
    <CardDivider no-body-padding no-margin class="d-md-none" />
    <div class="d-flex d-md-none justify-content-center my-3">
      <a class="btn btn-primary ihjoz-button ihjoz-button-big-size flex-grow-1" data-toggle="collapse" href="#invoice-drawer">
        Detailed Invoice
      </a>
    </div>
    <div id="invoice-drawer" class="invoice-drawer collapse d-md-flex">
      <CardDivider no-body-padding />
      <template v-if="showBillingShippingSection">
        <BillingShippingAddress :invoice="invoice" />
        <CardDivider no-body-padding />
      </template>
      <div class="invoice-row px-i">
        <div class="invoice-description">
          <InvoiceSubject v-if="invoice.subject" :subject="invoice.subject" />
          <InvoiceDescriptionAndAttachedFiles :description="invoice.text_description" :invoice-attachments="invoice.description ? invoice.description.files : []" />

          <LineItemsTable :invoice="invoice" />
          <NotesAndConditions
            :notes="invoice.notes"
            :conditions="invoice.conditions"
            :qr-code-url="invoice.barcode_url" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardDivider from "@shared/components/UI/CardDivider.vue";
import MerchantLogo from "./MerchantLogo.vue";
import MerchantInvoiceDetails from "./MerchantInvoiceDetails.vue";
import BillingShippingAddress from "./BillingShippingAddress.vue";
import InvoiceSubject from "./InvoiceSubject.vue";
import InvoiceDescriptionAndAttachedFiles from "./InvoiceDescriptionAndAttachedFiles.vue";
import LineItemsTable from "./LineItemsTable.vue";
import NotesAndConditions from "./NotesAndConditions.vue";

export default {
  name: "InvoiceContent",

  components: {
    CardDivider,
    MerchantLogo,
    MerchantInvoiceDetails,
    BillingShippingAddress,
    InvoiceSubject,
    InvoiceDescriptionAndAttachedFiles,
    LineItemsTable,
    NotesAndConditions
  },

  props: {
    invoice: { type: Object },
    pillColorClass: { type: String }
  },

  computed: {
    company () {
      return this.invoice.merchant_info;
    },

    currentUser () {
      return Dashboard.currentUser;
    },

    userIsMerchant () {
      return this.currentUser && this.company.user_id === this.currentUser.id;
    },

    showBillingShippingSection () {
      return this.showBillingAddress || this.showShippingAddress || this.invoice.customer_info.customer_display_name;
    },

    showBillingAddress () {
      return ["address", "attention", "city", "country", "phone_number"].some(fieldDetail =>
        this.showCustomerDetail("billing", fieldDetail)
      );
    },

    showShippingAddress () {
      return ["address", "attention", "city", "country", "phone_number"].some(fieldDetail =>
        this.showCustomerDetail("shipping", fieldDetail)
      );
    }
  },

  methods: {
    showCustomerDetail (addressType, field) {
      return (
        this.invoice.customer_info[`customer_${addressType}_address`] &&
        this.invoice.customer_info[`customer_${addressType}_address`][field]
      );
    }
  }
};
</script>
